export enum SubdivisionMode {
    Add,
    Update
}